import * as React from 'react';
var DEFAULTS = {
    publish: function () { },
    subscribe: function () { },
    unsubscribe: function () { }
};
var SignalEventsContext = React.createContext(DEFAULTS);
export var useManager = function () { return React.useContext(SignalEventsContext); };
/*
 * Check if the event manager obtained through useManager is
 * the default object or it has been overridden by a provider
 */
export var isDefault = function (eventManager) {
    return eventManager === DEFAULTS;
};
export var SignalEventsContextProvider = function (_a) {
    var children = _a.children, eventManager = _a.eventManager;
    var manager = React.useMemo(function () {
        /*
          Don't setup event subscriptions or publishing on server-side render since
          it's just a single render pass and we have no mechanism to perform any teardown
        */
        return typeof window === 'undefined' ? DEFAULTS : eventManager;
    }, [eventManager]);
    return React.createElement(SignalEventsContext.Provider, { value: manager }, children);
};
SignalEventsContextProvider.displayName = 'SignalEventsContextProvider';
//# sourceMappingURL=signal-events-context-provider.js.map